module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unitlogin",
    staticStyle: {
      "background-image": "url(./static/images/1.png)",
      "background-size": "100% 100%"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "rgb(12, 218, 217)",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.changePage(1)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "9px"
    },
    attrs: {
      "src": _vm.url.url_3
    }
  }), _vm._v(" "), _c('span', [_vm._v("返回")])]), _vm._v(" "), _vm._l((_vm.editInfo), function(item) {
    return _c('div', {
      key: item.name,
      staticClass: "display_row_ac",
      staticStyle: {
        "color": "rgb(12, 218, 217)",
        "height": "37px"
      }
    }, [_c('div', {
      staticClass: " display_row_jc_ac dispaly_flex00",
      staticStyle: {
        "width": "90px"
      }
    }, [_c('span', [_vm._v(_vm._s(item.name) + ":")])]), _vm._v(" "), _c('div', {
      staticClass: " display_row_ac dispaly_flex11 ",
      staticStyle: {
        "width": "300px"
      }
    }, [_c('Input', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": '请输入' + item.name
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "showmodel_1hz display_row_ac media_w_showmodel1hz",
    staticStyle: {
      "height": "auto",
      "color": "rgb(12, 218, 217)",
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "showmodel_1hz_2 display_row_ac dispaly_flex11 ",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "piccolumn1",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "register_comp"
    }
  }, [_vm._l((_vm.photosurl), function(item, index) {
    return _c('div', {
      key: item.ID,
      staticStyle: {
        "position": "relative",
        "width": "15vh",
        "height": "12vh",
        "margin-right": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "position": "absolute",
        "width": "100%",
        "text-align": "right",
        "z-index": "2",
        "float": "right",
        "top": "0px",
        "right": "0px"
      },
      on: {
        "click": function($event) {
          return _vm.deletepic(index)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": require("../../../static/images/icon_delete.png")
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "viewer",
        rawName: "v-viewer"
      }]
    }, [_c('img', {
      staticStyle: {
        "width": "15vh",
        "height": "12.5vh"
      },
      attrs: {
        "src": item.path
      }
    })])])
  }), _vm._v(" "), _c('Upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.forbidimg),
      expression: "!forbidimg"
    }],
    ref: "upload",
    staticStyle: {
      "width": "114px"
    },
    attrs: {
      "show-upload-list": false,
      "before-upload": _vm.handleBeforeUpload,
      "on-success": _vm.uplloadSucess,
      "format": ['jpg', 'png'],
      "action": _vm.uploadUrl,
      "data": _vm.uploadData,
      "type": "drag"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0.5vh",
      "height": "12vh"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload-outline",
      "size": "42"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "height": "46px",
      "line-height": "16px"
    }
  }, [_vm._v("图片拖至此处或者单击选择图片")])], 1)])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "display_row_jc_ac "
  }, [_c('input', {
    staticClass: "login_btn2",
    attrs: {
      "type": "button",
      "value": "保  存"
    },
    on: {
      "click": function($event) {
        return _vm.checkCreditCode()
      }
    }
  })])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " display_row_jc_ac dispaly_flex00",
    staticStyle: {
      "width": "90px"
    }
  }, [_c('span', [_vm._v("营业执照照片:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-fc5be34a"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/login/companyregistered.vue
// module id = 1089
// module chunks = 1